/**
 * @file index.js
 * @author sunxiaofeng01
 * @desc 百家号文章管理 —— 法律
 */

import Vuex from 'vuex';
import bendsdk from '@baidu/bend-plugin-sdk';
import store from '@/store/index';
import eventBus from '@/store/modules/EventBus';
import lawLinkUrl from '@/components/law-bjh-tip/lawLinkUrl';
const EventBus = new Vuex.Store(eventBus);

const routes = [
    {
        path: '/bjhContent',
        name: 'bjhContent',
        meta: {auth: 'in'},
        component: () => import('./views/index.vue'),
        // 拦截路由，直接跳转到百家号文章管理页面
        beforeEnter: (to, from, next) => {
            if (from.name && store.state.lawStore && store.state.lawStore.authenticationStatus !== 7) {
                EventBus.commit('emitEvent', {name: 'global_authentice'});
            }
            else {
                store.dispatch('lawStore/openWindow', lawLinkUrl.bjhContent);
            }
            next(false);
        }
    }
];

// 如果有权限控制的话，这里得引入SDK判断权限是否可以调用本插件，或者重插件配置页面读取插件信息
export default class bjhContent extends bendsdk.plugin {
    onInstall(router) {
        Array.prototype.push.apply(router.options.routes, routes);
        router.addRoutes(routes);
    }
}
